import {createFeatureSelector, createSelector} from '@ngrx/store';
import {StoreKeys} from '../../models/store-keys';
import {EntityFilterState} from './entity-filter/reducer/entity-filter.reducer';
import {EntitySearchItemsState} from './entity-search-item/reducer/entity-search-items.reducer';
import {EntitySearchResultState} from './entity-search-result/reducer/entity-search-result.reducer';
import { EntityViewState } from './entity-view/reducer/entity-view.reducer';


export const selectEntityFilterFeature = createFeatureSelector<EntityFilterState>(StoreKeys.ENTITY_FILTERS);

export const selectEntityFilterDatas = createSelector(selectEntityFilterFeature, state => state.datas);
export const selectEntityFilterDatasFilterItems = createSelector(selectEntityFilterFeature, state => state.datas.filterItems);
export const selectEntityFilterDatasLastAgg = createSelector(selectEntityFilterFeature, state => state.datas.lastAgg);

export const selectEntitySearchItemFeature = createFeatureSelector<EntitySearchItemsState>(StoreKeys.ENTITY_SEARCH_ITEMS);

export const selectEntitySearchItemDatas = createSelector(selectEntitySearchItemFeature, state => state.datas);

export const selectEntitySearchResultFeature = createFeatureSelector<EntitySearchResultState>(StoreKeys.ENTITY_SEARCH_RESULT);
export const selectEntitySearchResultLoading = createSelector(selectEntitySearchResultFeature, state => state.loading);
export const selectEntitySearchResultLoadAgg = createSelector(selectEntitySearchResultFeature, state => state.loadAgg);

export const selectEntitySearchResultDatas = createSelector(selectEntitySearchResultFeature, state => state.datas);
export const selectEntitySearchResultDatasContent = createSelector(selectEntitySearchResultDatas, state => state?.content);

export const selectEntityViewFeature = createFeatureSelector<EntityViewState>(StoreKeys.ENTITY_VIEW);
export const selectEntityViewDatas = createSelector(selectEntityViewFeature, state => state.datas);
export const selectEntityViewLoading = createSelector(selectEntityViewFeature, state => state.loading);
export const selectEntityViewError = createSelector(selectEntityViewFeature, state => state.error);
